import request from '@/services/api'

async function sendGamesSchedule(postData: any) {
  const path = '/schools/games-schedule'

  try {
    const response = await request(path, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(postData)
    })

    const data = await response.json()
    return data
    // console.log('Success')
  } catch (error) {
    console.error('Error:', error)
    throw error
  }
}

async function getGamesSchedule(childId: number) {
  const path = `/schools/games-schedule?childId=${childId}`

  try {
    const response = await request(path, {
      method: 'GET'
    })

    const data = await response.json()
    return data
    // console.log('Success')
  } catch (error) {
    console.error('Error:', error)
    throw error
  }
}

async function updateGamesSchedule(sessionId: number, postData: any) {
  const path = `/schools/games-schedule?sessionId=${sessionId}`

  try {
    const response = await request(path, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(postData)
    })

    const data = await response.json()
    return data
    // console.log('Success')
  } catch (error) {
    console.error('Error:', error)
    throw error
  }
}

export default { sendGamesSchedule, getGamesSchedule, updateGamesSchedule }
